@let hotel = hotel$ | async;
<div [editableInStoryblok]="_editable()" class="flex flex-col">
	@if (carousel()) {
		<sb-carousel
			[alignment]="heroAlignment"
			[contentMargin]="'small'"
			[items]="carousel().items"
			[verticalAlignment]="heroVerticalAlignment"
		/>
	}
	<div class="z-10 -mt-10 px-3 md:px-8">
		<div class="section-inner">
			<sb-availability-widget
				[accommodationTypes]="hotelStore.accommodationTypes()"
				[currency]="hotelStore.currency() || 'EUR'"
				[hotelGuid]="hotelGUID() || hotel?.guid"
				[hotelSlug]="hotelSlug() || hotel?.slug"
				[includeVhiHotels]="includeVhiHotels()"
				[language]="currentLanguage()"
				[openAvailabilityInNewTab]="openInNewTab()"
				[showAccommodationTypes]="true"
			/>
		</div>
	</div>
</div>
